
import { ISelectOption } from 'app/interfaces/ISelectOption';

export const compressionOptionValues = {
    BZip2: 'BZip2',
    Deflate: 'Deflate',
    Fastest: 'Fastest',
    GZip: 'GZip',
    None: 'None',
    Optimal: 'Optimal',
    ZipDeflate: 'ZipDeflate',
    TarGZip: 'TarGZip'
};

export type TypeAllOptionValue = 'None' | 'BZip2' | 'GZip' | 'Deflate' | 'ZipDeflate';
export type TypeOptionValue = 'BZip2' | 'GZip' | 'Deflate' | 'ZipDeflate' | 'TarGZip';
export type LevelOptionValue = 'Fastest' | 'Optimal';

export const typeOptions: Array<ISelectOption<TypeOptionValue>> = [
    {
        label: stringResources.None,
        value: compressionOptionValues.None as TypeOptionValue
    },
    {
        label: stringResources.Dataset_CompressionType_Option_BZip2,
        value: compressionOptionValues.BZip2 as TypeOptionValue
    },
    {
        label: stringResources.Dataset_CompressionType_Option_GZip,
        value: compressionOptionValues.GZip as TypeOptionValue
    },
    {
        label: stringResources.Dataset_CompressionType_Option_Deflate,
        value: compressionOptionValues.Deflate as TypeOptionValue
    },
    {
        label: stringResources.Dataset_CompressionType_Option_ZipDeflate,
        value: compressionOptionValues.ZipDeflate as TypeOptionValue
    },
    {
        label: stringResources.Dataset_CompressionType_Option_TarGZip,
        value: compressionOptionValues.TarGZip as TypeOptionValue
    }
];

export const levelOptions: Array<ISelectOption<LevelOptionValue>> = [
    {
        label: stringResources.Dataset_CompressionLevel_Option_Fastest,
        value: compressionOptionValues.Fastest as LevelOptionValue
    },
    {
        label: stringResources.Dataset_CompressionLevel_Option_Optimal,
        value: compressionOptionValues.Optimal as LevelOptionValue
    }
];
